// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__MLTKM","header":"ReportDetails_header__JJZYJ","title":"ReportDetails_title__3BWSc","left":"ReportDetails_left__1IbRR"};